module.exports = __webpack_public_path__ + "static/SQUARE_dock-15851fd55118b922fa9d6b810801a59f.jpeg";